import React, { useEffect, useRef } from 'react';
import Input from '@/components/General/inputs/Input';

/**
 * Renders `email` schema fields. Uses the shared `Input` with an email keyboard
 * type. Email format validation runs in `FormView` (client-side) and the submit
 * edge function.
 *
 * Autofill: when `field.config.autofillLoggedIn` is true and a `loggedInUser`
 * is provided, the field pre-fills with the user's email once on mount if empty.
 */
const EmailField = ({ field, value, onChange, disabled, loggedInUser }) => {
    const didAutofill = useRef(false);
    const config = field.config || {};

    useEffect(() => {
        if (didAutofill.current) return;
        if (disabled || typeof onChange !== 'function') return;
        if (config.autofillLoggedIn === false || !loggedInUser) return;
        if (value) return;

        didAutofill.current = true;
        onChange(loggedInUser.email ?? '');
    }, [config.autofillLoggedIn, loggedInUser, value, onChange]);

    return (
        <Input
            testID={`form-field-${field.fieldId}`}
            title={field.label}
            placeholder={field.placeholder}
            value={value ?? ''}
            onUpdate={onChange}
            type="email"
            required={field.required}
            helpText={field.description}
            disabled={disabled}
            autoCapitalize="none"
            autoComplete="email"
        />
    );
};

export default EmailField;
